import { Card, Grid, Input, Button, Divider, KPIStatistic } from "@scuf/common";
import { useEffect, useState } from "react";
import AnimationDomo from "../../components/Domo/AnimationDomo";
import MineralCard from "../../components/mineral-card/MineralCard";
import { getResultadoDomo } from "../../services/services";
// Importación de estilos
import "./AnimationDomoPage.css";
// Importamos valores staticos del domo
import VECTOR_MINERALES from "../../json/vector-minerales";

/**
 * Funcion que retorna la page donde el domo tendra sus componentes
 * @returns
 */
export default function AnimationDomoPage() {
  // state para capturar el valor del input donde se ingresara los grados
  const [inputValue, setInputValue] = useState(0);
  // state que se enviara al componente para mover el reclamador
  const [valueDomo, setValueDomo] = useState(0);
  const [minerales, setMinerales] = useState(VECTOR_MINERALES);
  const [isLoading, setIsLoading] = useState(false);
  const [startAndEndTheta, setStartAndEndTheta] = useState({
    start: 0,
    end: 0,
  });

  function SetMineralsData(data) {
    let updatedArray = minerales;
    Object.keys(data).forEach((key) => {
      updatedArray = updatedArray.map((obj) => {
        if (obj.name === key) {
          if (typeof data[key] === "number") {
            return { ...obj, value: data[key].toFixed(2) };
          }
          return { ...obj, value: data[key] };
        }
        return obj;
      });
    });
    setMinerales(updatedArray);
  }

  // Carga inicial de datos de la página
  useEffect(() => {
    // Hacer carga de datos
    async function fetchData() {
      setIsLoading(true);
      const { data } = await getResultadoDomo();
      const { ThetaFin, ThetaIni } = data[0];
      setStartAndEndTheta({ start: ThetaIni, end: ThetaFin });
      setIsLoading(false);
    }

    fetchData();
  }, []);
  /**
   * Función que valida el input value y setea el siguiente valor
   */
  function setPosition() {
    // llamamos el valor de carga a true
    setIsLoading(true);
    if (inputValue >= 0 && inputValue <= 360) {
      setValueDomo(inputValue);

      // Hacer carga de datos
      async function fetchData() {
        setIsLoading(true);
        const { data } = await getResultadoDomo({ theta: inputValue });
        const { ThetaFin, ThetaIni } = data[0];
        setStartAndEndTheta({ start: ThetaIni, end: ThetaFin });
        SetMineralsData(data[0]);
        setIsLoading(false);
      }

      fetchData();
    } else {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Card>
        <Card.Header title="PILA EN RECLAMACIÓN" />
        <Divider />
        <Card.Content className="content-pila-reclamacion">
          <Grid className="grid-reclamacion">
            <Grid.Row>
              <Grid.Column
                className="mineral-card-content"
                width={4}
                xsWidth={12}
                lWidth={4}
                mWidth={12}
                sWidth={12}
              >
                <AnimationDomo position={valueDomo} />
              </Grid.Column>

              <Grid.Column
                className="mineral-card-content"
                width={8}
                xsWidth={12}
                lWidth={8}
                mWidth={12}
                sWidth={12}
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={12}>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column
                            key={1}
                            className="grid-container-input-button"
                            width={4}
                          >
                            <Card>
                              <Card.Header
                                title={
                                  "Angulos de Pila: Pila A (55° - 160°) - Pila B (200°-305°)"
                                }
                              />

                              <Card.Content>
                                <div className="input-button-container">
                                  <Input
                                    className="input-animation-domo"
                                    placeholder="0"
                                    onChange={(value) => setInputValue(value)}
                                    value={inputValue}
                                    onEnter={setPosition}
                                  />
                                  <Button
                                    className="set-button"
                                    type="primary"
                                    content="Buscar"
                                    onClick={setPosition}
                                  />
                                </div>
                              </Card.Content>
                            </Card>
                          </Grid.Column>
                          <Grid.Column width={6}>
                            <Card>
                              <Card.Content>
                                <div style={{ display: "flex" }}>
                                  <KPIStatistic
                                    title=""
                                    value={startAndEndTheta.start + " °"}
                                    valueColor="green"
                                    targetValue="Ángulo inicial de la pila"
                                  />
                                  <KPIStatistic
                                    title=""
                                    value={startAndEndTheta.end + " °"}
                                    valueColor="orange"
                                    targetValue="Ángulo final de la pila"
                                  />
                                </div>
                              </Card.Content>
                            </Card>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>

                    {minerales.map((item, index) =>
                      item.name !== "Metodo" ? (
                        <Grid.Column key={index} width={2} xsWidth={8}>
                          <MineralCard
                            key={index}
                            title={item.name}
                            unit={item.unit}
                            value={item.value}
                            isLoading={isLoading}
                          />
                        </Grid.Column>
                      ) : (
                        ""
                      )
                    )}
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    </>
  );
}
